@let property = $property();
@if (property) {
  <div class="container">
    <i class="pi pi-hammer property-icon"></i>
    <span class="property-text">{{ property?.name }}</span>
    <i
      class="pi pi-times property-icon clickable"
      (mousedown)="oplocked.toggle($event)"
    ></i>
  </div>
  <p-overlayPanel #oplocked>
    <div class="title">Remove this suggestion?</div>
    <div class="buttons-container">
      <p-button
        label="No"
        class="button button-no"
        size="small"
        variant="outlined"
        (onClick)="oplocked.hide()"
      />
      <p-button
        label="Yes"
        size="small"
        class="button"
        [raised]="true"
        severity="danger"
        (onClick)="oplocked.hide(); ignoreSuggestedProperty.emit(property)"
      />
    </div>
  </p-overlayPanel>
}
